import { useMediaQuery } from "@mui/material";

/**
 * Column count of a dashboard card grid at the current viewport — the same
 * breakpoints the section SCSS caps its grid at (4 → 3 → 2 → 1). Sections
 * with "Show more" keep one full row visible and reveal the rest.
 */
const useCardGridColumns = () => {
  const lg = useMediaQuery("(min-width:1280px)", { noSsr: true });
  const md = useMediaQuery("(min-width:992px)", { noSsr: true });
  const sm = useMediaQuery("(min-width:600px)", { noSsr: true });

  if (lg) return 4;
  if (md) return 3;
  if (sm) return 2;
  return 1;
};

export default useCardGridColumns;
